// extracted by mini-css-extract-plugin
export var circleBlock = "circle-block-module--circle-block--2vL_z";
export var icon = "circle-block-module--icon--3vLXW";